<div class="w-full h-full flex justify-center items-center px-4 py-8">
  <div class="w-full max-w-md border border-white/15 rounded-xl bg-[#0b1230]/80 p-6 sm:p-8 shadow-xl">
    <div *ngIf="!isSubmitted">
      <h2 class="text-white text-xl font-semibold">Design Partner Registration</h2>
      <p class="text-sm text-white/70 mt-2 mb-5">
        Tell us about your organization and we will reach out shortly.
      </p>

      <form (ngSubmit)="submit()" class="space-y-4">
        <div>
          <label class="text-white/80 text-sm block mb-1">Company Name</label>
          <input
            type="text"
            name="companyName"
            [(ngModel)]="companyName"
            class="w-full bg-transparent text-white border rounded-md px-3 py-2 outline-none"
            [ngClass]="hasError('companyName') ? 'border-red-500' : 'border-white/20'"
            placeholder="Enter company name"
          />
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Contact Name</label>
          <input
            type="text"
            name="contactName"
            [(ngModel)]="contactName"
            class="w-full bg-transparent text-white border rounded-md px-3 py-2 outline-none"
            [ngClass]="hasError('contactName') ? 'border-red-500' : 'border-white/20'"
            placeholder="Enter contact name"
          />
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Country</label>
          <select
            name="country"
            [(ngModel)]="country"
            class="w-full bg-[#0d1638] text-white border rounded-md px-3 py-2 outline-none"
            [ngClass]="hasError('country') ? 'border-red-500' : 'border-white/20'"
          >
            <option [ngValue]="null">Select Country</option>
            <option *ngFor="let countryItem of countryOptions" [ngValue]="countryItem">
              {{ countryItem.name }}
            </option>
          </select>
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Mobile</label>
          <div
            class="flex items-center border rounded-md px-3 py-2"
            [ngClass]="hasError('mobile') ? 'border-red-500' : 'border-white/20'"
          >
            <span class="text-white/70 mr-2">{{ country?.country_code || '+--' }}</span>
            <input
              type="text"
              name="mobileNo"
              [(ngModel)]="mobileNo"
              class="w-full bg-transparent text-white outline-none"
              [attr.maxLength]="country?.mobile_number_length"
              [attr.minLength]="country?.mobile_number_length"
              placeholder="Enter mobile number"
            />
          </div>
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Email</label>
          <input
            type="email"
            name="email"
            [(ngModel)]="email"
            class="w-full bg-transparent text-white border rounded-md px-3 py-2 outline-none"
            [ngClass]="hasError('email') ? 'border-red-500' : 'border-white/20'"
            placeholder="Enter email address"
          />
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Password</label>
          <div
            class="flex items-center border rounded-md px-3 py-2"
            [ngClass]="hasError('password') ? 'border-red-500' : 'border-white/20'"
          >
            <input
              type="password"
              name="password"
              [(ngModel)]="password"
              class="w-full bg-transparent text-white outline-none"
              #passwordInput
              minlength="8"
              placeholder="Create a password (min. 8 characters)"
            />
            <button
              type="button"
              class="text-white/70 hover:text-white ml-2"
              (click)="togglePasswordVisibility(passwordInput)"
            >
              <i *ngIf="!showPassword" class="fas fa-eye-slash"></i>
              <i *ngIf="showPassword" class="fas fa-eye"></i>
            </button>
          </div>
        </div>

        <div>
          <label class="text-white/80 text-sm block mb-1">Number of certificates managed</label>
          <input
            type="number"
            min="0"
            name="certificatesManaged"
            [(ngModel)]="certificatesManaged"
            class="w-full bg-transparent text-white border rounded-md px-3 py-2 outline-none"
            [ngClass]="hasError('certificatesManaged') ? 'border-red-500' : 'border-white/20'"
            placeholder="Enter number of certificates"
          />
        </div>

        <button
          type="submit"
          [disabled]="isSubmitting"
          class="w-full h-11 bg-[#31a1f6] text-white rounded-md font-medium hover:bg-[#2387d6] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ isSubmitting ? 'Submitting...' : 'Submit Registration' }}
        </button>

        <button
          type="button"
          (click)="navigateToLogin()"
          class="w-full text-sm text-[#9ed3ff] hover:text-[#31a1f6] transition-colors"
        >
          Back to Login
        </button>
      </form>
    </div>

    <div *ngIf="isSubmitted" class="text-center py-4">
      <h3 class="text-white text-lg font-semibold">Request Received</h3>
      <p class="text-white/70 text-sm mt-2">
        Thanks for your interest. You can sign in with your email and password once your account is ready.
      </p>
      <button
        type="button"
        (click)="navigateToLogin()"
        class="mt-5 h-10 px-5 bg-[#31a1f6] text-white rounded-md hover:bg-[#2387d6] transition-colors"
      >
        Go to Login
      </button>
    </div>
  </div>
</div>
